import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { useAuth } from '../contexts/AuthContext';
import { Header } from '../components/header/Header';
import * as Sentry from '@sentry/react';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context }) => {
    const { firebaseGetUser } = context.auth;
    const currentUser = await firebaseGetUser();
    const currentURL = window.location.href;
    // HANDLE REDIRECTS FOR AN UNAUTHENTICATED USER
    // TODO: REMOVE THE CHECK ON CAPTURE WHEN WE HAVE TIME TO TEST ALL INCOMING URLS (AND REMOVE REQUESTED URL ON EVERY PAGE LOAD)
    if (!currentUser && currentURL.includes('capture')) {
      window.localStorage.setItem('requestedURL', currentURL);
      throw redirect({
        to: '/',
      });
    }
  },
  component: WithHeader,
});

function WithHeader() {
  let patientId = '123';
  const { currentUser } = useAuth();
  if (currentUser) {
    patientId = currentUser.uid;
    Sentry.setUser({
      id: currentUser.uid,
      email: currentUser.email ? currentUser.email : 'unknown email',
    });
  }

  return (
    <div className="bg-slate-100">
      <div className="fixed top-0 w-full">
        <Header patientId={patientId} />
      </div>
      <div className="mx-4 mt-20 mb-8 flex h-full flex-col items-center rounded-lg border-4 border-solid border-sky-700 bg-stone-100 px-4 py-8">
        <Outlet />
      </div>
    </div>
  );
}
